<template>
	<div class="icon-exit">
		<svg
			width="24.000000"
			height="24.000000"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_2205">
					<rect
						id="Fill=false"
						width="24.000000"
						height="24.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_2205)">
				<path
					id="path"
					d="M15.24 22.27L15.11 22.27C10.67 22.27 8.53 20.52 8.16 16.6C8.12 16.18 8.42 15.82 8.84 15.78C9.24 15.74 9.62 16.04 9.66 16.45C9.95 19.6 11.43 20.77 15.12 20.77L15.25 20.77C19.32 20.77 20.76 19.33 20.76 15.26L20.76 8.73C20.76 4.66 19.32 3.22 15.25 3.22L15.12 3.22C11.41 3.22 9.93 4.41 9.66 7.61C9.61 8.03 9.26 8.34 8.84 8.3C8.42 8.27 8.12 7.89 8.15 7.48C8.49 3.51 10.64 1.72 15.11 1.72L15.24 1.72C20.15 1.72 22.25 3.83 22.25 8.73L22.25 15.26C22.25 20.16 20.15 22.27 15.24 22.27Z"
					:fill="isHover ? 'var(--theme-color)' : color"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
				<path
					id="path"
					d="M14.99 12.75L3.61 12.75C3.2 12.75 2.86 12.4 2.86 12C2.86 11.59 3.2 11.25 3.61 11.25L14.99 11.25C15.4 11.25 15.74 11.59 15.74 12C15.74 12.4 15.4 12.75 14.99 12.75Z"
					:fill="isHover ? 'var(--theme-color)' : color"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
				<path
					id="path"
					d="M5.84 16.09C5.65 16.09 5.46 16.02 5.31 15.87L1.96 12.52C1.67 12.23 1.67 11.75 1.96 11.47L5.31 8.11C5.6 7.82 6.08 7.82 6.37 8.11C6.66 8.4 6.66 8.88 6.37 9.17L3.55 11.99L6.37 14.81C6.66 15.1 6.66 15.58 6.37 15.87C6.23 16.02 6.03 16.09 5.84 16.09Z"
					:fill="isHover ? 'var(--theme-color)' : color"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
	props: {
		isHover: { type: Boolean, default: false },
		color: { type: String, default: "rgb(188, 192, 207)" },
	},
})
export default class IconExit extends Vue {}
</script>

<style scoped lang="scss">
.icon-exit {
	display: flex;
}
</style>
